import user from './userType';

const primary = [
	['#1C1C1C', '#12BCF3', '', '#12BCF3B2', '#12BCF366', '#12BCF333'], // Brand
	['#1C1C1C', '#F96152', '', '#F96152B2', '#F9615266', '#F9615233'], // Consumer
	['#1C1C1C', '#FEBF3B', '0', '#FEBF3BB2', '#FEBF3B66', '#FEBF3B33'], // Host
	['#1C1C1C', '#6645F4', '#E0DAFD', '#6645F4B2', '#6645F466', '#6645F433'], // Seller
	['#1C1C1C', '#6645F4', '#E0DAFD', '#6645F4B2', '#6645F466', '#6645F433'], // Admin
];

const palettes = {
	dark: [
		'#101625', // 0
		'#1A2234', // 1
		'#303D51', // 2
		'#48546A', // 3
		'#616E82', // 4
	],
	grey: [
		'#7C889B', // 0
		'#98A2B2', // 1
		'#B3BCC8', // 2
		'#C3CAD4', // 3
		'#E0E4E9', // 4
		'#EFF1F4', // 5
		'#F3F6F9', // 6
		'#DADFE5', // 7
		'#506279', // 8
		'#FAFBFC', // 9
		'#828D9F', //10
	],
	primary: primary[user],
	red: [
		'#F96152', // 0
		'#F96152B2', // 1
		'#F9615266', // 2
		'#F9615233', // 3
	],
	purple: [
		'#6645F4', // 0
		'#6645F4B2', // 1
		'#6645F466', // 2
		'#6645F433', // 3
	],
	blue: [
		'#2068F4', // 0
		'#F9F8FF', // 1
	],
	yellow: [
		'#FEBF3B', // 0
		'#FEBF3BB2', // 1
		'#FEBF3B66', // 2
		'#FEBF3B33', // 3
		'#FFF8EA', // 4
	],
	light: ['#FFFFFF'],
	green: ['#49BD4E'],
};

export default palettes;
